import React, { useEffect, useState } from 'react';
import Tabs, { Tab } from 'components/Tabs';
import BuscaComercial from './tabs/BuscaComercial';
import Oportunidade from './tabs/Oportunidade';
import { usePermit } from 'utils/hooks/usePermit';
import { Permissao, Role } from 'utils/variables';
import NotFound from 'components/NotFound';
import NaoAutorizado from 'assets/naoautorizado.svg';

export default function ORA() {
  const hasOpec = usePermit([Role.OPEC], []);
  const hasORA = usePermit([], [Permissao.ORA]);
  const [activeTabIndex, setActiveTabIndex] = useState(hasOpec ? 2 : 1);
  const [palavraChaveSearch, setPalavraChaveSearch] = useState('');

  return (
    <div>
      {!hasORA && !hasOpec ? (
        <div>
          <NotFound img={NaoAutorizado} title="ACESSO NÃO AUTORIZADO">
            Você não tem permissão para acessar essa página
          </NotFound>
        </div>
      ) : (
        <Tabs>
          {hasORA && (
            <Tab
              title="OPORTUNIDADES"
              id={1}
              height="calc(100vh - 130px)"
              checked={activeTabIndex === 1}
              onChange={() => setActiveTabIndex(1)}
            >
              <Oportunidade
                setPalavraChaveSearch={setPalavraChaveSearch}
                setActiveTabIndex={setActiveTabIndex}
              />
            </Tab>
          )}
          <Tab
            title="BUSCA DE COMERCIAIS"
            id={2}
            height="calc(100vh - 130px)"
            checked={activeTabIndex === 2}
            onChange={() => setActiveTabIndex(2)}
          >
            <BuscaComercial palavraChaveSearch={palavraChaveSearch} />
          </Tab>
        </Tabs>
      )}
    </div>
  );
}
